<script setup>
import { ref, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import ArrowUpLine from "@/assets/arrow-up-line.png";
import ArrowDownLine from "@/assets/arrow-down-line.png";
import ArrowDownDoubleLine from "@/assets/arrow-down-double-line.png";
import AppInfo from "@/assets/app-info.png";

const { query, path } = useRoute();

const showAppFnWithBookId = [853];

const fold = ref(true);
const showLoading = ref(true);
const showScrollTips = ref(true);

const showAppFn = computed(() => {
  return query.booksId && showAppFnWithBookId.includes(Number(query.booksId));
});

const onLoadInfoImg = () => {
  showLoading.value = false;
};

let scrollEndTimer = null;

const onScrollImg = (e) => {
  showScrollTips.value = false;
  clearTimeout(scrollEndTimer);
  scrollEndTimer = setTimeout(() => {
    onScrollEndImg(e);
  }, 100);
};

const onScrollEndImg = (e) => {
  const { scrollTop, scrollHeight, clientHeight } = e.target;
  setTimeout(() => {
    showScrollTips.value = true;
    if (
      scrollTop + clientHeight >= scrollHeight ||
      scrollTop + clientHeight < 0
    ) {
      showScrollTips.value = false;
    }
  }, 0);
};

onMounted(() => {
  // if (path === "/booklet") {
  //   fold.value = false;
  // } else {
  //   fold.value = true;
  // }
});
</script>

<template>
  <van-overlay :show="showLoading" z-index="3001">
    <div
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
      "
    >
      <van-loading />
    </div>
  </van-overlay>

  <div v-show="showAppFn" @touchmove.stop>
    <div class="app-fn-box" id="wakeup-btn" v-show="fold" @click="fold = !fold">
      <div class="text">
        <span>了解更多APP功能</span>
        <van-image width="10" height="5" :src="ArrowUpLine" />
      </div>
    </div>

    <div v-show="!fold" class="app-info">
      <div class="app-info-title">
        <div @click="fold = !fold">
          <span>收起</span>
          <van-image
            width="10"
            height="5"
            :src="ArrowDownLine"
            class="title-img"
          />
        </div>
      </div>
      <div class="app-info-content" @scroll="onScrollImg">
        <van-image
          width="100%"
          :src="AppInfo"
          style="display: block"
          @load="onLoadInfoImg"
        />
      </div>
      <div class="app-info-tips" v-show="showScrollTips">
        <span>滑动查看更多</span>
        <van-image width="16" height="16" :src="ArrowDownDoubleLine" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.app-fn-box {
  position: fixed;
  bottom: calc(68px + env(safe-area-inset-bottom));
  left: 50%;
  transform: translateX(-50%);
  width: 223px;
  height: 66px;
  background: url("@/assets/app-fn.png") no-repeat;
  background-size: 100% 100%;
}
.text {
  font-size: 14px;
  line-height: 22px;
  color: #000000d9;
  position: absolute;
  left: 65px;
  top: 20px;
  display: flex;
  align-items: center;
  span {
    margin-right: 4px;
  }
}
.app-info {
  position: fixed;
  bottom: calc(80px + env(safe-area-inset-bottom));
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 438px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0px 0px 16px #7593b229;
  display: flex;
  flex-direction: column;
}
.app-info-title {
  font-size: 14px;
  width: 66px;
  height: 30px;
  color: #000000d9;
  background-color: #fff;
  border-radius: 90px;
  display: flex;
  justify-content: flex-end;
  position: absolute;
  z-index: 100;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  & > div {
    width: fit-content;
    height: 22px;
    display: flex;
    align-items: center;
  }
  .title-img {
    margin-left: 4px;
  }
}
.app-info-content {
  width: 100%;
  height: 100%;
  border-radius: 16px;
  overflow-y: scroll;
  background-color: #fff;
  overscroll-behavior: none;
  &::-webkit-scrollbar {
    display: none;
  }
}
.app-info-tips {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 27px;
  background: #fff;
  opacity: 0.9;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    font-size: 14px;
    color: #666666ff;
    margin-right: 4px;
  }
}
</style>
